export default __webpack_public_path__ + "static/media/Melissa_9781408341643.8d2c98ff.jpg";